// Import everything from autoload folder
import './autoload/ada-compliance.js'; import './autoload/foundation.js'; // eslint-disable-line

// Import local dependencies
import './plugins/lazyload';
import './plugins/modernizr.min';
import 'slick-carousel';
import 'jquery-match-height';
import objectFitImages from 'object-fit-images';
import '@fancyapps/fancybox/dist/jquery.fancybox.min';
// import { jarallax, jarallaxElement } from 'jarallax';
// import ScrollOut from 'scroll-out';
// eslint-disable-next-line no-unused-vars
import Swiper from 'swiper';

/**
 * Import scripts from Custom Divi blocks
 */
// eslint-disable-next-line import/no-unresolved
//import '../blocks/divi/example-block/index.js';

/**
 * Import scripts from Custom Elementor widgets
 */
// eslint-disable-next-line import/no-unresolved
import '../blocks/elementor/cards-slider-widget/index.js'; import '../blocks/elementor/example-widget/index.js'; import '../blocks/elementor/expertise-widget/index.js'; import '../blocks/elementor/image-slider-widget/index.js';

/**
 * Import scripts from Custom ACF Gutenberg blocks
 */
// eslint-disable-next-line import/no-unresolved
//import '../blocks/gutenberg/acf-example-block/index.js';

/**
 * Init foundation
 */
$(document).foundation();

/**
 * Fit slide video background to video holder
 */
function resizeVideo() {
  let $holder = $('.videoHolder');
  $holder.each(function () {
    let $that = $(this);
    let ratio = $that.data('ratio') ? $that.data('ratio') : '16:9';
    let width = parseFloat(ratio.split(':')[0]);
    let height = parseFloat(ratio.split(':')[1]);
    $that.find('.video').each(function () {
      if ($that.width() / width > $that.height() / height) {
        $(this).css({
          width: '100%',
          height: 'auto',
        });
      } else {
        $(this).css({
          width: ($that.height() * width) / height,
          height: '100%',
        });
      }
    });
  });
}

function minimizeHeader() {
  const header = document.querySelector('.elementor-location-header');

  if (window.pageYOffset > 0) {
    header.classList.add('is-minimize');
  } else {
    header.classList.remove('is-minimize');
  }
}

/**
 * Scripts which runs after DOM load
 */
$(document).on('ready', function () {
  /**
   * Make elements equal height
   */
  $('.matchHeight').matchHeight();

  // $('#search-page-query article.elementor-post').matchHeight();

  /**
   * IE Object-fit cover polyfill
   */
  if ($('.of-cover').length) {
    objectFitImages('.of-cover');
  }

  // $('.gallery-item')
  //   .find('a[href$="jpg"], a[href$="png"], a[href$="gif"]')
  //   .attr('rel', 'gallery')
  //   .attr('data-fancybox', 'gallery');
  // $(
  //   '.fancybox, a[rel*="album"], a[href$="jpg"], a[href$="png"], a[href$="gif"]'
  // ).fancybox({
  //   minHeight: 0,
  //   helpers: {
  //     overlay: {
  //       locked: false,
  //     },
  //   },
  // });

  /**
   * Add fancybox to galleries
   */
  function initializeFancybox(gallerySelector, arrowColor) {
    if (window.innerWidth < 1023) {
      $(gallerySelector).fancybox({
        btnTpl: {
          arrowLeft: `<svg data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}" xmlns="http://www.w3.org/2000/svg" width="22.397" height="41.807"><g id="Triangle" fill="none" stroke-miterlimit="10"><path d="M14 0l14 15H0z" transform="rotate(-90 19.65 15.254)"/><path d="M14 0L0 15h28L14 0m0-4.397l2.193 2.35 14 15L34.903 18H-6.903l4.71-5.047 14-15L14-4.397z" fill="#1a73be" transform="rotate(-90 19.65 15.254)"/></g></svg>`,
          arrowRight: `<svg data-fancybox-next class="fancybox-button fancybox-button--arrow_right" xmlns="http://www.w3.org/2000/svg" width="22.397" height="41.807"><g id="Triangle_Copy" data-name="Triangle Copy" fill="none" stroke-miterlimit="10"><path d="M14 0l14 15H0z" transform="rotate(90 5.548 12.452)"/><path d="M14 0L0 15h28L14 0m0-4.397l2.193 2.35 14 15L34.903 18H-6.903l4.71-5.047 14-15L14-4.397z" fill="#1a73be" transform="rotate(90 5.548 12.452)"/></g></svg>`,
        },
      });
    } else {
      $(gallerySelector).fancybox({
        btnTpl: {
          arrowLeft: `<svg data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}" xmlns="http://www.w3.org/2000/svg" width="36.924" height="69.233"><g id="slider-arrow-left" fill="none" stroke-miterlimit="10"><path d="M30 0l30 32H0z" transform="rotate(-90 33.77 30.846)"/><path d="M30 0L0 32h60L30 0m0-2.924l1.46 1.556 30 32L64.615 34H-4.616l3.157-3.368 30-32L30-2.924z" fill="${arrowColor}" transform="rotate(-90 33.77 30.846)"/></g></svg>`,
          arrowRight: `<svg data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}" xmlns="http://www.w3.org/2000/svg" width="36.924" height="69.233"><g id="slider-arrow-right" fill="none" stroke-miterlimit="10"><path d="M30 0l30 32H0z" transform="rotate(90 14.692 19.308)"/><path d="M30 0L0 32h60L30 0m0-2.924l1.46 1.556 30 32L64.615 34H-4.616l3.157-3.368 30-32L30-2.924z" fill="${arrowColor}" transform="rotate(90 14.692 19.308)"/></g></svg>`,
        },
      });
    }
  }

  initializeFancybox('[data-fancybox="gallery"]', '#1a73be');

  initializeFancybox('[data-fancybox="team-gallery"]', '#1a73be');

  /**
   * Init parallax
   */
  // jarallaxElement();
  // jarallax(document.querySelectorAll('.jarallax'), {
  //   speed: 0.5,
  // });

  /**
   * Detect element appearance in viewport
   */
  // ScrollOut({
  //   offset: function() {
  //     return window.innerHeight - 200;
  //   },
  //   once: true,
  //   onShown: function(element) {
  //     if ($(element).is('.ease-order')) {
  //       $(element)
  //         .find('.ease-order__item')
  //         .each(function(i) {
  //           let $this = $(this);
  //           $(this).attr('data-scroll', '');
  //           window.setTimeout(function() {
  //             $this.attr('data-scroll', 'in');
  //           }, 300 * i);
  //         });
  //     }
  //   },
  // });

  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = () => {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };

  removeFieldPlaceholder();

  $(document).on('gform_post_render', () => {
    removeFieldPlaceholder();
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function (event, formId) {
    let $target = $('#gform_confirmation_wrapper_' + formId);
    if ($target.length) {
      $('html, body').animate({ scrollTop: $target.offset().top - 50 }, 500);
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on(
    'change keyup',
    '.gfield input, .gfield textarea, .gfield select',
    function () {
      let $field = $(this).closest('.gfield');
      if ($field.hasClass('gfield_error') && $(this).val().length) {
        $field.find('.validation_message').hide();
      } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
        $field.find('.validation_message').show();
      }
    }
  );

  /**
   * Add `is-active` class to menu-icon button on Responsive menu toggle
   * And remove it on breakpoint change
   */
  $(window)
    .on('toggled.zf.responsiveToggle', function () {
      $('.menu-icon').toggleClass('is-active');
    })
    .on('changed.zf.mediaquery', function () {
      $('.menu-icon').removeClass('is-active');
    });

  /**
   * Close responsive menu on orientation change
   */
  $(window).on('orientationchange', function () {
    setTimeout(function () {
      if ($('.menu-icon').hasClass('is-active') && window.innerWidth < 641) {
        $('[data-responsive-toggle="main-menu"]').foundation('toggleMenu');
      }
    }, 200);
  });

  resizeVideo();
});

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function () {
  // jQuery code goes here
  minimizeHeader();

  let $preloader = $('.preloader');
  if ($preloader.length) {
    $preloader.addClass('preloader--hidden');
  }
});

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function () {
  // jQuery code goes here

  resizeVideo();
});

/**
 * Scripts which runs on scrolling
 */
$(window).on('scroll', function () {
  // jQuery code goes here
  minimizeHeader();
});
